import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Main from '../components/Main/Main';
import Intro from './../pages/Intro';
import History from '../pages/History';
import Directions from '../pages/Directions';
import BoardList from '../components/Board/BoardList';
import BoardDetail from '../components/Board/BoardDetail';

const Router = () => {
  const location = useLocation();

  useEffect(() => {
    // 페이지가 변경될 때 스크롤을 최상단으로 이동
    window.scrollTo(0, 0);
  }, [location]); // location이 변경될 때마다 실행

  return (
    <Routes>
      <Route path="/" element={<Main />}></Route>
      {/* ABOUT */}
      <Route path="/about/intro" element={<Intro />}></Route>
      <Route path="/about/history" element={<History />}></Route>
      <Route path="/about/directions" element={<Directions />}></Route>
      {/* GAMES, JOURNAL, NEWS, CONTACT US*/}
      <Route path="/board/:category" element={<BoardList />}></Route>
      <Route path="/board/:category/:idx" element={<BoardDetail />}></Route>
    </Routes>
  );
};

export default Router;
